// extracted by mini-css-extract-plugin
export default {"estado":"solicitudes-form_estado__QprIi"};